import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about/rondy-stickers-lettering-yes-1 1.png")